import { html, LitElement } from 'lit-element';

/**
 * @element response-block-ecr
 * @prop {Object} response - Response
 */
export class ResponseBlockECR extends LitElement {
  static get properties() {
    return {
      response: { type: Object, attribute: false },
      correctnessGroup: { type: String, attribute: false },
    };
  }

  openModal({ name, avatar }) {
    if (this.correctnessGroup === 'unanswered') {
      return;
    }

    const content = html`<response-modal-ecr
      .response=${this.response}
    ></response-modal-ecr>`;

    const title = html`
      <div class="modal-response-header">
        ${avatar}
        <span class="student-name">${name || ''}</span>
      </div>
    `;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'response-modal-ecr',
          modalTitle: title,
        },
      })
    );
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { sessionData, item, student } = this.response || {};
    const { name, photo, isOnline } = student || {};
    const { choices, element } = item || {};
    const { value = {} } = sessionData || {};
    const online = isOnline || isOnline === undefined;
    const blockClasses =
      this.correctnessGroup && this.correctnessGroup === 'unanswered'
        ? 'block'
        : 'block expandable';

    // TODO
    if (element !== 'explicit-constructed-response') {
      return null;
    }

    let avatar;
    const opacityClass = !online ? 'offline-opacity' : '';
    const avatarClasses = `block-avatar ${opacityClass}`;

    if (photo) {
      avatar = html`<img class=${avatarClasses} src="${photo}" />`;
    } else {
      const initials = (name || '')
        .split(' ')
        .map(namePart => (namePart ? namePart[0] : ''));

      avatar = html`<div class=${avatarClasses}>${initials}</div>`;
    }

    const areaKeys = Object.keys(choices || {});

    return html` <div
      class=${online ? blockClasses : `${blockClasses} offline`}
      @click=${() => this.openModal({ name, avatar })}
    >
      ${avatar}
      <div class="block-details">
        <span class=${`student-name ${opacityClass}`}>${name || ''}</span>

        <div>
          ${areaKeys.map((area, index) => {
            const isCorrect = (choices[area] || []).find(
              ch => ch.label === value[area]
            );
            const isLast = index >= areaKeys.length - 1;
            const className = value[area]
              ? `${isCorrect ? 'correct' : 'incorrect'}-answer`
              : '';

            return html` <span class="${className}">
              ${value[area] || '_____'} ${isLast ? '' : ', '}
            </span>`;
          })}
        </div>
      </div>
      ${!online
        ? html`<div class="offline-label-top offline-opacity">offline</div>`
        : ''}
    </div>`;
  }
}

export default ResponseBlockECR;
